import Vue from 'vue';
import App from './Embed.vue';

const app = new Vue({
  el: '#app',
  render: h => h(App),
});

window.app = app;



// WEBPACK FOOTER //
// ./src/dobrodelen/embed.js